module.exports = __webpack_public_path__ + "static/media/Fotolia_44430275_800x500.3c880876.jpg";